import { getMatchByIdRequest, getMatchRequest } from "../repositories/match_repository";

export const MatchService = () => {
  const fetchMatch = async (setMatchData) => {
    try {
      const response = await getMatchRequest();
      if (response?.success) {
        setMatchData(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch match data.");
    }
  };

  const fetchMatchById = async (id) => {
    try {
      const response = await getMatchByIdRequest(id);
      if (response?.success) {
        return response.data;
      } else {
        console.error("Failed to fetch match details : ", response?.errors);
        throw new Error(response?.errors || "Failed to fetch match details.");
      }
    } catch (error) {
      console.error("Error in fetchMatchById : ", error);
      throw error;
    }
  }
  return {
    fetchMatch,
    fetchMatchById,
  };
};
